/*eslint-disable*/
import '../App.css';
import '../Section.css';
import '../reset.css'
import '../seik-style.css'
import $ from 'jquery';
import 'animate.css';
import React, { useState, useEffect } from 'react';

function Section5() {

    const [marginBottom, setMarginBottom] = useState("200px");

    useEffect(() => {
        const handleScroll = () => {
            const section5 = document.querySelector('.section4');
    
            const section5Top = section5.offsetTop;
            const section5Height = section5.clientHeight;
            const halfwayPoint = section5Top + section5Height / 2 + 100;
    
            const scrollDifference = window.scrollY - halfwayPoint;
    
            // 스크롤 변화에 따라 marginBottom 값을 동적으로 계산하여 설정
            const dynamicMarginBottom = Math.min(Math.max(40 - scrollDifference, 40), 200);
    
            setMarginBottom(`${dynamicMarginBottom}px`);
        };
    
        window.addEventListener("scroll", handleScroll);
    
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []); // 빈 배열을 전달하여 useEffect를 한 번만 실행
    
    let news = [
        [`${process.env.PUBLIC_URL}/news4.jpg`, "Title님이 룬테라 리포지드 챔피언으로 등극했습니다!"],
        [`${process.env.PUBLIC_URL}/news5.jpg`, "별 수호자 지난 이야기"]
    ];
    return (
        <div className='section section5' style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/section5Bg.png)` }}>
            <p className='title' style={{ left: "-70px", top: "13.5%" }}>-&nbsp;추천&nbsp;-</p>
            <div className='section_box' style={{ color: "#000", paddingTop: "80px", marginBottom: marginBottom, transition: "margin 0.4s ease" }}>
                <h3 className='animate__animated animate__fadeInDown' style={{ fontSize: "25px" }}>더 자세히</h3>
                <h2 className='animate__animated animate__fadeInDown' style={{ fontSize: "60px" }}>알아보기</h2>
            </div>

            <div className='center' style={{ marginBottom: "100px" }}>
                {
                    news.map(function (newsItem, index) {
                        return (
                            <div className='news_box' key={index}>
                                <div className='news_box_border'
                                    onMouseOver={(e) => {
                                        const target = e.currentTarget;
                                        target.style.transform = "translate(-50%, -50%) scale(0.95)"; // 5% 축소
                                        target.style.backgroundColor = "#fff";
                                    }}
                                    onMouseOut={(e) => {
                                        const target = e.currentTarget;
                                        target.style.transform = "translate(-50%, -50%) scale(1)"; // 마우스 아웃 시 원래 크기로 복원
                                        target.style.backgroundColor = ""
                                    }}
                                >
                                    <div className='news_box_img' style={{backgroundImage: `url(${newsItem[0]})` }}></div>
                                    <h2>{newsItem[1]}</h2>
                                </div>
                            </div>

                        )
                    })
                }
            </div>
        </div>
    )
}

export default Section5